
import { ArrowRight } from "lucide-react";
import { Button, ContactButton } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Container } from "@/components/ui/container";
import { HeroBackground } from "@/components/ui/hero-background";

export const HeroSection = () => {
  return (
    <HeroBackground 
      pattern="grid" 
      colorScheme="purple"
      height="h-[600px] md:h-[700px]"
      className="animate-fade-in"
    >
      {/* Content container */}
      <Container className="py-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 id="hero-heading" className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight tracking-tight text-gray-900 animate-fade-up">
            NIST CSF{" "}
            <span className="bg-gradient-to-r from-edgefi-purple to-edgefi-amethyst bg-clip-text text-transparent">
              Consulting & Assessments
            </span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed font-light animate-fade-up" style={{ animationDelay: "0.1s" }}>
            Strengthen your security posture with NIST Cybersecurity Framework guidance. Our experts help you assess, implement, and maintain NIST CSF compliance to protect your organization.
          </p>
          <div className="flex flex-wrap justify-center gap-4 animate-fade-up" style={{ animationDelay: "0.2s" }}>
            <ContactButton
              className="bg-edgefi-purple hover:bg-edgefi-purple/90 text-white group"
              modalTitle="NIST CSF Consultation"
              modalDescription="Tell us about your NIST CSF compliance goals and challenges."
              variant="cta"
              size="lg"
            >
              Get a NIST CSF Assessment
              <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </ContactButton>
            <Link to="#framework">
              <Button variant="outline" size="lg" className="border-edgefi-purple/20">
                Explore the Framework
              </Button>
            </Link>
          </div>
        </div>
      </Container>
    </HeroBackground>
  );
};
